// extracted by mini-css-extract-plugin
export default {"button":"metamask-auth_button__n52eX","address":"metamask-auth_address__Xvaqr"};